import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { TripStepTypeEnum } from '../../lib/types/enums/trip-bookings/trip-step-type.enum'
import { TripBookingTypes } from '../../lib/types/models/trip-booking/trip-booking'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type TripTripTripbookingsFilter = {
  directionalities?: TripStepTypeEnum[]
  centerId: number
}

export function getTripTripbookings(
  id: number,
  input: PaginationRequest<TripTripTripbookingsFilter>
) {
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.trips.getTripTripbookings.url, { id }), input))
    .get<PaginationResponse<TripBookingTypes.Partial>>()
}
